"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = AuthError;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// src/common/components/AuthError.js

function AuthError(_ref) {
  var error = _ref.error;
  return error && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center p-4 mb-4 text-sm text-red-800 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400",
    role: "alert"
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "flex-shrink-0 inline w-4 h-4 mr-3",
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "sr-only"
  }, "Error"), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "font-medium"
  }, "Error:"), " ", error));
}